import { render, staticRenderFns } from "./belongToConsignment.vue?vue&type=template&id=15438a7b&scoped=true"
import script from "./belongToConsignment.vue?vue&type=script&lang=js"
export * from "./belongToConsignment.vue?vue&type=script&lang=js"
import style0 from "./belongToConsignment.vue?vue&type=style&index=0&id=15438a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15438a7b",
  null
  
)

export default component.exports